export default {
  // 设置基础信息
  SET_BASICINFO (state, data) {
    state.basicInfo = data
  },
  // 设置基础信息, 用于背景图列表
  SET_BASICINFOBGLIST (state, data) {
    state.basicInfoBgList = data
  },
  // 设置课件详情页页面包数据
  SET_PACKAGES (state, packages) {
    state.packages = packages
  },
  // 更新页面包数据
  UPDATE_PACKAGE (state, onePackageInfo) {
    let index
    let target = state.packages.find((item, i) => {
      index = i
      return item.id === onePackageInfo.id
    })
    if (target) {
      // 若更新的数据中包含页面包的属性信息。则需更改页面包下所有页面的互动、非互动信息
      if (onePackageInfo.package_attr) {
        target.pageInfo.forEach(page => {
          // 属性为普通，页面为非互动，其他属性，页面为互动
          if (onePackageInfo.package_attr == '1') {
            page.is_interact = '2'
          } else {
            page.is_interact = '1'
          }
        })
      }
      target = Object.assign({}, target, onePackageInfo)
      state.packages.splice(index, 1, target)
    }
  },
  // 设置课件基础信息
  SET_COURSEWARE_INFO (state, info) {
    state.coursewareInfo = Object.assign({}, state.coursewareInfo, info)
  },
  UPDATE_PAGE (state, info) {
    // 找到页面所在的页面包
    let index
    let pageIndex
    const targetPackage = state.packages.find((item, i) => {
      index = i
      return item.id === info.packageId
    })
    let targetPage
    if (targetPackage) {
      targetPage = targetPackage.pageInfo.find((item, j) => {
        pageIndex = j
        return item.id === info.pageId
      })
    }
    if (targetPage) {
      targetPage = Object.assign({}, targetPage, info.info)
      targetPackage.pageInfo.splice(pageIndex, 1, targetPage)
    }
    state.packages.splice(index, 1, targetPackage)
  },
  SET_FILTER_DATA (state, data) {
    state.filterData = Object.assign({}, state.filterData, data)
  },
  CLEAR_FILTER_DATA (state) {
    state.filterData = {
      type: '1',
      status: null,
      gradeIds: null,
      termIds: null,
      versionId: null,
      difficultyId: null,
      yearId: null,
      searchType: null,
      keyword: null,
      curpage: 1,
      perpage: 20
    }
  },
  SET_BACK_STATUS (state, backstatus) {
    state.backStatus = backstatus
  }
}



// WEBPACK FOOTER //
// ./src/store/courseware/mutations.js